/** What each factor category is called to a customer, not to the engine.
 *
 * One home: the Sources declaration form and the factor library both name a category, and two
 * maps would eventually disagree about whether `fugitive` is "Refrigerant top-ups". A category not
 * listed is shown as its own code with underscores spaced, never dropped.
 */
export const CATEGORY_LABEL: Record<string, string> = {
  stationary: "Fuel burned on site",
  mobile: "Fuel for transport",
  fugitive: "Refrigerant top-ups",
  process: "Process emissions",
  electricity: "Purchased electricity",
  steam: "Purchased steam",
  heat: "Purchased heat",
  cooling: "Purchased cooling",
};

export function categoryLabel(category: string): string {
  return CATEGORY_LABEL[category] ?? category.replace(/_/g, " ");
}
